import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';
import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';
import { RecipientExpansionStatus } from 'owa-recipient-types/lib/types/RecipientExpansionStatus';
import isValidRecipientAddress from 'owa-recipient-email-address/lib/utils/isValidRecipientAddress';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isUnicodeWhitespaceLikeString } from 'owa-unicode-utils/lib/isUnicodeWhitespaceLikeString';
import getEmailWithRoutingType from 'owa-recipient-email-address/lib/utils/getEmailWithRoutingType';
import getDisplayNameAndAddressFromRecipientString from 'owa-recipient-email-address/lib/utils/getDisplayNameAndAddressFromRecipientString';
import parseOneOffEmailAddressFromString from 'owa-recipient-email-address/lib/utils/parseOneOffEmailAddressFromString';
import dangerousCreateSMTPEmailAddressWithoutValidation from 'owa-recipient-email-address/lib/utils/dangerousCreateSMTPEmailAddressWithoutValidation';
/**
 * Maps FindRecipientPersonaType to ReadWriteRecipientViewState
 */
export default function(
    newPersona: FindRecipientPersonaType,
    isValid: boolean,
    newEmailAddress?: string
): ReadWriteRecipientViewState {
    if (!newPersona) {
        const nameAndAddress = getDisplayNameAndAddressFromRecipientString(newEmailAddress);
        newPersona = {
            EmailAddress:
                parseOneOffEmailAddressFromString(
                    nameAndAddress.address,
                    nameAndAddress.displayName
                ) || dangerousCreateSMTPEmailAddressWithoutValidation(newEmailAddress),
        };
    }

    // Some recipients don't have an EmailAddress name, but do have
    // DisplayNames on their personas (e.g. MAPIPDLs in the GAL)
    //
    // handle that here.
    let requestedDisplayName = newPersona.DisplayName || newPersona.EmailAddress.Name;
    const nameIsNullOrWhitespace =
        !requestedDisplayName || isUnicodeWhitespaceLikeString(requestedDisplayName);

    const shouldDisplayEmailAddressInsteadOfName =
        // Some distribution type (e.g. MAPIPDL) have no EmailAddress, so we can
        // only display them with their display name.
        newPersona.EmailAddress.EmailAddress &&
        // Otherwise, if the display name is suspicious (e.g. empty) or not present,
        // show the email address as well.
        nameIsNullOrWhitespace;

    let displayText = shouldDisplayEmailAddressInsteadOfName
        ? requestedDisplayName && !nameIsNullOrWhitespace
            ? `${requestedDisplayName} <${getEmailWithRoutingType(newPersona.EmailAddress)}>`
            : getEmailWithRoutingType(newPersona.EmailAddress)
        : requestedDisplayName;

    if (!isConsumer()) {
        let emailDomain = newPersona.EmailAddress.EmailAddress
            ? newPersona.EmailAddress.EmailAddress.split('@')[1]
            : '';

        let isExternalMailboxType =
            newPersona.EmailAddress.MailboxType === 'ExternalMailbox' ||
            newPersona.EmailAddress.MailboxType === 'LinkedIn';

        // this is for when name is a SMTP.
        // If the name is SMTP, then if the domain of the display text is different than Email Address then show the email address domain
        // If they are the same, do not show the domain name after name.
        if (
            displayText &&
            (!isValidRecipientAddress(displayText) || displayText.split('@')[1] !== emailDomain) &&
            isExternalMailboxType
        ) {
            displayText = `${displayText} (${emailDomain})`;
        }
    }

    return {
        persona: newPersona,
        displayText: displayText,
        isValid: isValid,
        // TODO 55605 remove this when we stop deferring insertion until after resolution
        isPendingResolution: false,
        isContextMenuOpen: false,
        isSelected: false,
        isExpanding: false,
        isEditing: false,
        isFadedOut: false,
        expansionStatus: RecipientExpansionStatus.None,
        members: [],
    };
}
